import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import VehicleForm from './VehicleForm';
import WarningNotiifcation from 'components/WarningNotification';
import { connect } from 'react-redux';
import { updateMany } from 'services';
import ReCAPTCHA from 'react-google-recaptcha';
import { SetLoading } from "redux/actions/loadingActions";
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";
import { SetHasVehicle } from "redux/actions/hasVehicleDataActions";
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
let yup = require('yup');

const VehicleFormWrapper = ({data, user, SetLoading, SetHasVehicle, SetOperationSuccess, opeationSuccess, hasVehicleDataReducer }) => {
    const [reCAPTCHA, setReCAPTCHA] = useState('');
    const reRef = useRef();
    const [vehicleForm, setVehicleForm] = useState([]);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([]);
    const [loadForm, setLoadForm] = useState(false);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const formRef = useRef();
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
   const history = useHistory();

    useEffect(() => {
        (async function mounted() {
            setExampleOptionsArray(() => {
                return [{ value: '', label: 'Seleccione...' }, { value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]
            });
            
            if (data && data.length > 0) {
                user.persona.personaVehiculo = data;
                let schema = {};
                let values = {};
                let vehicles = [];

                data.forEach(vehicle => {
                    const vehicleId = vehicle.id;
                    schema = {
                        ...schema,
                        [`type_${vehicleId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`model_${vehicleId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`brand_${vehicleId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`year_${vehicleId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                    };
                    values = {
                        ...values,
                        [`type_${vehicleId}`]: vehicle.licenciaConducirTipoId,
                        [`model_${vehicleId}`]: vehicle.modeloId,
                        [`brand_${vehicleId}`]: vehicle.marcaId,
                        [`year_${vehicleId}`]: vehicle.fabricadoEn,
                    };
                    vehicles.push({
                        id: vehicleId,
                        estado: vehicle.estado,
                        isNew: false,
                    })
                });

                setBasicSchema(() => {
                    return schema;
                });
                
                updateFormik(schema);

                setFormContent(() => {
                    return values
                });

                setVehicleForm(() => {
                    return [
                        ...vehicles
                    ];
                });
            }
            setLoadForm(true);
        })();
    }, [data])

    useEffect(() => {
        if (loadForm) {
            if (data && data.length == 0) {
                onAddVehicleForm();
            }
        }
    }, [loadForm]) 

    const onSaveAndContinue = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(true);
                formRef.current.handleSubmit();
            }
        })
    }

    const onSave = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(false);
                formRef.current.handleSubmit();
            }
        })
    }

    const onContinue = () => {
        history.push({
          pathname: "/education",
          state: {
            updateUserData: true,
          },
        });
      };

    const onExit = () => {
        history.push({
            pathname: "/vehicle",
            state: {
                updateUserData: true
            }
        });
    }

    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });

    const onAddVehicleForm = () => {
        const guid = uuid();
        const oldValues = formRef.current.values;

        const newSchema = {
            ...basicSchema,
            [`type_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`model_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`brand_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`year_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
        };

        setBasicSchema(() => {
            return newSchema;
        });
        
        setFormContent(() => {
            return {
                ...oldValues,
                [`type_${guid}`]: '',
                [`model_${guid}`]: '',
                [`brand_${guid}`]: '',
                [`year_${guid}`]: '',
            }
        });
        
        setVehicleForm(() => {
            return [
                ...vehicleForm,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
        
        updateFormik(newSchema);
    };

    const onRemoveVehicleForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = vehicleForm.find(x => x.id === identifier);

        const schemaKeys = [
            `type_${identifier}`, 
            `model_${identifier}`, 
            `brand_${identifier}`, 
            `year_${identifier}`, 
        ];

        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return oldValues
        });
        
        updateFormik(newSchema);
        if (removedForm.isNew) {
            setVehicleForm(() => {
                return [
                    ...vehicleForm.filter(x => x.id !== identifier)
                ]
            })
        } else {
            const index = vehicleForm.indexOf(removedForm);
            let updatedvehicleForm = vehicleForm;
            removedForm.estado = 0;
            updatedvehicleForm[index] = removedForm;
            setVehicleForm(() => {
                return [
                    ...updatedvehicleForm
                ]
            })
        }
    };

    const onFormSubmitted = async (form) => {
        try {
        let personaVehiculos = [];
        vehicleForm.forEach(vehicle => {
            const modeloId = (vehicle.estado === 0)
                ? parseInt(user.persona.personaVehiculo.find(x => x.id ===  vehicle.id)?.modeloId)
                : parseInt(form['model_' + vehicle.id]);
            
            const marcaId = (vehicle.estado === 0)
                ? parseInt(user.persona.personaVehiculo.find(x => x.id ===  vehicle.id)?.marcaId)
                : parseInt(form['brand_' + vehicle.id]);

            const licenciaConducirTipoId = (vehicle.estado === 0)
                ?  parseInt(user.persona.personaVehiculo.find(x => x.id ===  vehicle.id)?.licenciaConducirTipoId)
                : parseInt(form['type_' + vehicle.id]);

            const fabricadoEn = (vehicle.estado === 0)
                ?  parseInt(user.persona.personaVehiculo.find(x => x.id ===  vehicle.id)?.fabricadoEn)
                : parseInt(form['year_' + vehicle.id]);    
            const personaVehiculo = {
                id: vehicle.isNew ? null : vehicle.id,
                personaId: user.persona.id,
                estado: vehicle.estado,
                licenciaConducirTipoId,
                modeloId,
                marcaId,
                fabricadoEn
            }
            personaVehiculos.push(personaVehiculo);
        });
        
        setIsLoading(true);
        const response = await updateMany('PersonaVehiculo', personaVehiculos);
        if (response && response.data && response.data.some(x => x.estado == 1)) {
            SetHasVehicle(true);
        } else {
            SetHasVehicle(false);
        }
        SetOperationSuccess(opeationSuccess + 1);

        const route = saveAndContinue ? "/education" : "/vehicle";
        history.push({
            pathname: route,
            state: {
                updateUserData: true
            }
        });

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            setReCAPTCHA('');
        }
        
    };

    return (
        <>
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner 
                        animation="grow" 
                        variant="primary" 
                        className={'is-absolute center-spinner-vertically'} 
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-40'}>
                    {
                        loadForm &&
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={formikSchema}
                                onSubmit={onFormSubmitted}
                                initialValues={formContent}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <Form.Row>
                                            <Form.Group 
                                                as={Col} 
                                                md="12" 
                                                controlId="campos_obligatorios"
                                                className="mb-25"
                                                style={{fontSize: 18}}>
                                                    <div>
                                                        <b> Campos obligatorios * </b>
                                                    </div>
                                            </Form.Group>

                                            {
                                                (vehicleForm.length > 0 && vehicleForm.filter(x => x.estado === 1).length > 0) ?
                                                vehicleForm.filter(x => x.estado === 1).map((element) => {
                                                    return <VehicleForm 
                                                        key={element.id} 
                                                        handleChange={handleChange} 
                                                        errors={errors} 
                                                        touched={touched} 
                                                        values={values} 
                                                        element={element}
                                                        removeVehicleForm={onRemoveVehicleForm}
                                                        options={exampleOptionsArray} />
                                                })
                                                : 
                                                <Form.Group as={Col} md="12">
                                                    <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Vehículos'/>
                                                </Form.Group>
                                            }
                                            <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                                <Button onClick={onAddVehicleForm}> Agregar </Button>
                                            </Form.Group>
                                        </Form.Row>
                                        {
                                            vehicleForm.length > 0 && 
                                            <Form.Group className={'display-flex space-between padding-right-0'}  as={Col} md="12">
                                                {
                                                    hasVehicleDataReducer 
                                                    ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                    : <div> </div>
                                                }
                                                <div>
                                                    <Button size="medium" type="button" onClick={onSave}> <b> Guardar </b> </Button>
                                                    <Button className={'margin-left-5'} size="medium" type="button" onClick={onSaveAndContinue}> <b> Guardar y continuar </b> </Button>
                                                    <Button size="medium" type="button" className={'margin-left-5'} onClick={onContinue}> {" "} <b> Continuar </b>{" "} </Button>
                                                </div>
                                            </Form.Group>
                                        }
                                    </Form>
                                    )}
                            </Formik>
                        </div>
                    }
                </Card.Body>
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasVehicleDataReducer: state.hasVehicleDataReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetHasVehicle: (value) => dispatch(SetHasVehicle(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(VehicleFormWrapper);